<template>
  <div class="bm-mobile block xl:hidden" :class="{ 'bm-mobile--open': isOpen }">
    <!-- 展開的書籤夾 -->
    <transition name="bm-expand">
      <div
        v-if="isOpen"
        class="fixed top-[4.2rem] right-0 bottom-0 w-48 z-[200] bg-[#1a1a1a] border-l border-white/10 flex flex-col justify-center py-8"
      >
        <button
          v-for="(page, i) in pages"
          :key="page.route"
          class="bm-mobile__item bg-transparent border-none border-b border-white/[0.08] px-6 py-4 text-left cursor-pointer transition-colors duration-150 flex items-center justify-between w-full first:border-t first:border-white/[0.08] disabled:cursor-default"
          :class="{ 'bg-[rgba(195,14,35,0.18)]': i === currentIndex }"
          :style="{ transitionDelay: `${i * 40}ms` }"
          :disabled="i === currentIndex"
          @click="i !== currentIndex && select(page.route)"
        >
          <span
            class="text-[0.8rem] font-bold tracking-[0.1em]"
            :class="i === currentIndex ? 'text-[#c30e23] tracking-[0.14em]' : 'text-[rgba(232,232,232,0.5)]'"
          >{{ page.label }}</span>
          <span
            v-if="i === currentIndex"
            class="w-[5px] h-[5px] rounded-full bg-[#c30e23] shrink-0"
          ></span>
        </button>
      </div>
    </transition>

    <!-- 遮罩 -->
    <transition name="bm-overlay">
      <div
        v-if="isOpen"
        class="fixed inset-0 z-[190] bg-black/60"
        @click="close"
      ></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'BookmarkMobile',
  props: {
    pages: { type: Array, default: () => [] },
    currentIndex: { type: Number, default: 0 },
  },
  emits: ['navigate', 'close'],
  data() {
    return { isOpen: false }
  },
  methods: {
    toggle() { this.isOpen = !this.isOpen },
    close()  { this.isOpen = false; this.$emit('close') },
    select(route) {
      this.close()
      this.$emit('navigate', route)
    },
  },
}
</script>

<style lang="scss" scoped>
.bm-mobile__item:hover:not(:disabled) {
  background: rgba(195, 14, 35, 0.1);
}

.bm-expand-enter-active,
.bm-expand-leave-active { transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1); }
.bm-expand-enter-from,
.bm-expand-leave-to     { transform: translateX(100%); }

.bm-overlay-enter-active,
.bm-overlay-leave-active { transition: opacity 0.28s; }
.bm-overlay-enter-from,
.bm-overlay-leave-to     { opacity: 0; }
</style>
